import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import { Formik } from 'formik';
import {
  AppFormikTextArea,
  AppFormikTextField,
  AppPrimaryButton,
  AppPrimaryButtonOutlined,
} from 'shared/components/AppComponents';
import { ReactElement } from 'react';
import { serverGuardSchema } from 'validators/GuardTrailSchema';

const CreateServerDialog = (props: any): ReactElement => {
  const { open, onCloseServer, serverForm, actionOnSubmit } = props;

  return (
    <>
      <Dialog
        maxWidth="sm"
        fullWidth
        open={open}
        onClose={() => {
          onCloseServer(false);
        }}
      >
        <DialogTitle>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box>
              <Typography variant="h3">
                {serverForm.name !== '' ? 'Update' : 'Register'} Server
              </Typography>
            </Box>
            <IconButton
              onClick={() => {
                onCloseServer(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
        </DialogTitle>
        <Formik
          initialValues={serverForm}
          validationSchema={serverGuardSchema}
          enableReinitialize
          validateOnMount
          onSubmit={(formValues, formik) => {
            actionOnSubmit(formValues, formik);
          }}
        >
          {({ handleSubmit, isSubmitting, isValid }) => (
            <>
              <DialogContent>
                <AppFormikTextField
                  name="name"
                  outerLabel
                  label="Name"
                  placeholder="My MCP Server"
                />
                <AppFormikTextField
                  name="endpoint"
                  outerLabel
                  label="Endpoint url"
                  placeholder="https://my-mcp-server.example.com/mcp"
                />
                <AppFormikTextArea
                  name="description"
                  outerLabel
                  label="Description (optional)"
                  placeholder="What does this do ?"
                />
              </DialogContent>
              <DialogActions>
                <Stack
                  className="mx-4 mb-4"
                  direction="row"
                  spacing={2}
                  alignItems="center"
                >
                  <AppPrimaryButtonOutlined
                    title="Cancel"
                    className="btn-small"
                    onClick={() => {
                      onCloseServer(false);
                    }}
                  />
                  <AppPrimaryButton
                    isLoading={isSubmitting}
                    onClick={handleSubmit}
                    disabled={!isValid || isSubmitting}
                    loadingText="Saving"
                    title={`${
                      serverForm.name !== '' ? 'Update' : 'Register'
                    } Server`}
                    className="btn-small"
                  />
                </Stack>
              </DialogActions>
            </>
          )}
        </Formik>
      </Dialog>
    </>
  );
};

export default CreateServerDialog;
